import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokenStorageService } from '../services/token-storage.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private _tokenService: TokenStorageService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                let errors: any[] = [];

                if (err.status === 401) {
                    const isAuthUrl =
                        request.url.includes('GetAccess') ||
                        request.url.includes('RefreshThirdPartyToken');

                    if (isAuthUrl) {
                        return throwError(() => err);
                    }

                    this._tokenService.signOut();
                    location.reload();
                    return throwError(() => err);
                }

                if (err.status === 400) {
                    if (err?.error?.errors?.[0]?.ErrorMessageEn || err?.error?.errors?.[0]?.errorMessageEn) {
                        errors = err.error.errors;
                    } else if (err?.error?.info?.info) {
                        errors = [{ errorMessageEn: err.error.info.info }];
                    } else {
                        errors = [{ errorMessageEn: 'An unexpected error occurred' }];
                    }
                }
                return throwError(() => errors);
            })
        );
    }
}
